/** Add `delta` calendar days to a YYYY-MM-DD date (UTC), returning YYYY-MM-DD. */
export function addDays(date: string, delta: number): string {
  const parts = date.split('-').map(Number);
  const y = parts[0] as number;
  const m = parts[1] as number;
  const d = parts[2] as number;
  const next = new Date(Date.UTC(y, m - 1, d + delta));
  return next.toISOString().slice(0, 10);
}
